import React from 'react';

const CarouselContext = React.createContext();

CarouselContext.propTypes = {};

CarouselContext.propTypesMeta = 'exclude';

export default CarouselContext;
